/**
 * `v3.runs.outcomeFileUrl` — a member's presigned GET for one file of a run's outcome,
 * scoped to the caller's customer, valid for `OUTCOME_PRESIGN_SECONDS`. Only a file the
 * outcome's latest record names is ever signed. Payloads live in `@fm/v3/outcomes`.
 *
 * A separate group from `V3RunRpcs` so its handler lives in its own router file.
 *
 * Handlers: `v3-run-outcomes.router.ts`.
 *
 * @since 1.0.0
 */
import { Rpc, RpcGroup } from "@effect/rpc";
import { OutcomeFileUrl, OutcomeFileUrlInput, OutcomeStorageError } from "@fm/v3/outcomes";
import { Schema } from "effect";
import { DatabaseError, Forbidden, RecordNotFoundError, Unauthorized, ValidationError } from "../errors.ts";
import { LoopActorMiddleware } from "../loop-actor.tags.ts";

/**
 * @since 1.0.0
 */
export class V3RunOutcomeRpcs extends RpcGroup.make(
  Rpc.make("v3.runs.outcomeFileUrl", {
    payload: OutcomeFileUrlInput,
    success: OutcomeFileUrl,
    error: Schema.Union(
      Unauthorized,
      Forbidden,
      RecordNotFoundError,
      ValidationError,
      DatabaseError,
      OutcomeStorageError,
    ),
  }).middleware(LoopActorMiddleware),
) {}
